export var MOVE_STATUS_UNKNOWN = -1;
export var MOVE_STATUS_ALLOW = 0;
export var MOVE_STATUS_ERROR = 1;
export var MOVE_STATUS_MULTI = 2;
export var MOVE_STATUS_PERMIT = 3;
export var MOVE_STATUS_CREATE_NOT_COMPLETE = 4;

// 对应 retcode 20010
export var MOVE_STATUS_SIZE_LIMIT_OWNER = 5;
export var RETCODE_MOVE_STATUS_SIZE_LIMIT_OWNER = 20010;

// 对应 retcode 20013
export var MOVE_STATUS_SIZE_LIMIT_COLLABORATOR = 6;
export var RETCODE_MOVE_STATUS_SIZE_LIMIT_COLLABORATOR = 20013;